export default "__VITE_ASSET__Btx_rUDH__"